import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Searchbar from "./Shearchbar";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Menubar from "./Manubar";
import Footer from "./Footer";
import Security from "./Security";
import {
  FaMobileAlt,
  FaShieldAlt,
  FaPaperPlane,
  FaSignInAlt,
  FaUserPlus,
  FaRedoAlt,
  FaArrowLeft,
  FaLock,
  FaClock,
} from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";

const Login = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [mobileNo, setMobileNo] = useState("");
  const [otp, setOtp] = useState("");
  const [numberMessage, setNumberMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [userId, setUserId] = useState("");
  const [token, setToken] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [otpTesting, setOtpTesting] = useState("");

  // Initialize resend timer on component mount
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleMobileSubmit = async (event) => {
    event.preventDefault();

    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobileNo)) {
      setNumberMessage("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsLoading(true);
    setNumberMessage("");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/signup`,
        { mobile_no: mobileNo },
      );

      if (res.data.result) {
        setUserId(res.data.data.user_id);
        setToken(res.data.data.token);
        setOtpTesting(res.data.data.otp);
        setOtpSent(true);
        setResendTimer(60);
        toast.success("OTP sent successfully to your mobile number");
      }
    } catch (error) {
      if (error.response?.data?.msg) {
        toast.error(error.response.data.msg);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async (event) => {
    event.preventDefault();

    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    console.log(otp);

    setIsLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/verify_otp`,
        {
          _id: userId,
          otp: otp,
        },
      );

      if (res.data.result) {
        secureLocalStorage.setItem("n_id", res.data.data.user_id);

        toast.success(
          activeTab === "register"
            ? "Registration successful!"
            : "Login successful!",
        );

        setMobileNo("");
        setOtp("");
        setOtpSent(false);
        setUserId("");
        setToken("");

        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
    } catch (error) {
      if (error.response?.data?.msg) {
        toast.error(error.response.data.msg);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0) return;

    setIsLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/resend_otp`,
        { mobile_no: mobileNo },
      );

      if (res.data.result) {
        setUserId(res.data.data._id);
        setToken(res.data.data.token);
        setOtpTesting(res.data.data.otp);
        setResendTimer(60);
        toast.success("New OTP sent successfully");
      }
    } catch (error) {
      if (error.response?.data?.msg) {
        toast.error(error.response.data.msg);
      } else {
        toast.error("Failed to resend OTP. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setMobileNo("");
    setOtp("");
    setOtpSent(false);
    setUserId("");
    setToken("");
    setNumberMessage("");
    setResendTimer(0);
    setIsLoading(false);
  };

  return (
    <div>
      <ToastContainer position="top-center" />

      <Searchbar />
      <Navbar />
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Menubar />
          </div>
        </div>
      </div>

      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  login &amp; register
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      <div className="login-register-area section-mb">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 mx-auto">
              <div className="login-register-wrapper">
                <div
                  className="login-register-tab-list nav nav-tabs"
                  id="nav-tab"
                  role="tablist"
                  style={{
                    border: "none",
                    justifyContent: "center",
                    marginBottom: "30px",
                    gap: "20px",
                  }}
                >
                  <a
                    className={`login-register-tab ${activeTab === "login" ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab("login");
                      resetForm();
                    }}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      position: "relative",
                      padding: "12px 30px",
                      borderRadius: "50px",
                      background:
                        activeTab === "login" ? "#1e40af" : "transparent",
                      color: activeTab === "login" ? "#fff" : "#888",
                      fontWeight: "600",
                      fontSize: "18px",
                      transition: "all 0.3s ease",
                      boxShadow:
                        activeTab === "login"
                          ? "0 5px 15px rgba(254, 232, 148, 0.3)"
                          : "none",
                      border:
                        activeTab === "login"
                          ? "2px solid #1e40af"
                          : "2px solid transparent",
                    }}
                  >
                    <h4 style={{ margin: 0, fontSize: "20px" }}>Login</h4>
                  </a>
                  <a
                    className={`login-register-tab ${activeTab === "register" ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab("register");
                      resetForm();
                    }}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      position: "relative",
                      padding: "12px 30px",
                      borderRadius: "50px",
                      background:
                        activeTab === "register" ? "#1e40af" : "transparent",
                      color: activeTab === "register" ? "#fff" : "#888",
                      fontWeight: "600",
                      fontSize: "18px",
                      transition: "all 0.3s ease",
                      boxShadow:
                        activeTab === "register"
                          ? "0 5px 15px rgba(254, 232, 148, 0.3)"
                          : "none",
                      border:
                        activeTab === "register"
                          ? "2px solid #1e40af"
                          : "2px solid transparent",
                    }}
                  >
                    <h4 style={{ margin: 0, fontSize: "20px" }}>Register</h4>
                  </a>
                </div>

                <div className="tab-content">
                  <div className="tab-pane show active">
                    <div
                      className="login-form-container"
                      style={{
                        backgroundColor: "#f9f7f2",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        boxShadow: "0 10px 30px rgba(22, 0, 21, 0.1)",
                        border: "1px solid rgba(254, 232, 148, 0.3)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      {/* Decorative elements */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-50px",
                          right: "-50px",
                          width: "150px",
                          height: "150px",
                          backgroundColor: "#1e40af",
                          borderRadius: "50%",
                          opacity: 0.7,
                        }}
                      ></div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "-30px",
                          left: "-30px",
                          width: "100px",
                          height: "100px",
                          background:
                            "linear-gradient(135deg, rgba(254, 232, 148, 0.4) 0%, rgba(254, 232, 148, 0.1) 100%)",
                          borderRadius: "50%",
                          opacity: 0.5,
                        }}
                      ></div>

                      <div className="login-register-form">
                        {!otpSent ? (
                          // Mobile Number Form
                          <form onSubmit={handleMobileSubmit}>
                            <div
                              className="mb-4"
                              style={{ position: "relative", zIndex: 2 }}
                            >
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "30px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    backgroundColor: "#1e40af",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 20px",
                                    boxShadow:
                                      "0 5px 15px rgba(254, 232, 148, 0.4)",
                                  }}
                                >
                                  <FaMobileAlt
                                    style={{
                                      fontSize: "30px",
                                      color: "#fff",
                                    }}
                                  />
                                </div>
                                <h5
                                  style={{
                                    color: "black",
                                    fontWeight: "700",
                                    marginBottom: "10px",
                                    fontSize: "24px",
                                  }}
                                >
                                  {activeTab === "login"
                                    ? "Login with Mobile Number"
                                    : "Register with Mobile Number"}
                                </h5>
                                <p
                                  style={{
                                    color: "#666",
                                    fontSize: "14px",
                                    marginBottom: "0",
                                  }}
                                >
                                  Enter your mobile number to receive OTP
                                </p>
                              </div>

                              <div style={{ marginBottom: "15px" }}>
                                <label
                                  style={{
                                    color: "#e74c3c",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "block",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {numberMessage}
                                </label>
                                <div
                                  style={{
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: "#1e40af",
                                      color: "#fff",
                                      padding: "14px 15px",
                                      borderRadius: "10px 0 0 10px",
                                      fontWeight: "600",
                                      border: "1px solid rgba(22, 0, 21, 0.1)",
                                      borderRight: "none",
                                    }}
                                  >
                                    +91
                                  </div>
                                  <input
                                    type="text"
                                    name="mobile_no"
                                    value={mobileNo}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      if (value.length <= 10) {
                                        setMobileNo(value);
                                      }
                                    }}
                                    placeholder="Enter 10-digit Mobile Number"
                                    maxLength="10"
                                    required
                                    disabled={isLoading}
                                    style={{
                                      width: "100%",
                                      padding: "12px 15px",
                                      borderRadius: "0 10px 10px 0",
                                      border: "1px solid rgba(22, 0, 21, 0.1)",
                                      fontSize: "16px",
                                      color: "#fff",
                                      background: "#fff",
                                      transition: "all 0.3s ease",
                                      outline: "none",
                                      boxSizing: "border-box",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className="button-box text-center"
                              style={{ position: "relative", zIndex: 2 }}
                            >
                              <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                  backgroundColor: "#1e40af",
                                  color: "#fff",
                                  border: "none",
                                  padding: "14px 40px",
                                  borderRadius: "50px",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease",
                                  width: "100%",
                                  maxWidth: "300px",
                                  margin: "0 auto",
                                  display: "block",
                                  boxShadow: "0 5px 15px rgba(22, 0, 21, 0.3)",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.boxShadow =
                                    "0 8px 20px rgba(22, 0, 21, 0.4)";
                                  e.target.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.boxShadow =
                                    "0 5px 15px rgba(22, 0, 21, 0.3)";
                                  e.target.style.transform = "translateY(0)";
                                }}
                              >
                                {isLoading ? (
                                  <span>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Sending OTP...
                                  </span>
                                ) : (
                                  <>
                                    <FaPaperPlane
                                      style={{
                                        marginRight: "8px",
                                        verticalAlign: "middle",
                                      }}
                                    />
                                    Send OTP
                                  </>
                                )}
                              </button>
                            </div>
                          </form>
                        ) : (
                          // OTP Verification Form
                          <form onSubmit={handleOtpSubmit}>
                            <div
                              className="mb-4"
                              style={{ position: "relative", zIndex: 2 }}
                            >
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "30px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    backgroundColor: "#1e40af",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 20px",
                                    boxShadow:
                                      "0 5px 15px rgba(254, 232, 148, 0.4)",
                                  }}
                                >
                                  <FaShieldAlt
                                    style={{
                                      fontSize: "30px",
                                      color: "#fff",
                                    }}
                                  />
                                </div>
                                <h5
                                  style={{
                                    color: "black",
                                    fontWeight: "700",
                                    marginBottom: "10px",
                                    fontSize: "22px",
                                  }}
                                >
                                  Enter OTP Sent to
                                </h5>
                                <p
                                  style={{
                                    color: "#fff",
                                    fontWeight: "600",
                                    fontSize: "18px",
                                    backgroundColor: "#1e40af",
                                    padding: "8px 15px",
                                    borderRadius: "10px",
                                    display: "inline-block",
                                    marginBottom: "20px",
                                  }}
                                >
                                  +91 {mobileNo}
                                </p>

                                {/* OTP Display for testing - can be removed in production */}
                                <div
                                  style={{
                                    padding: "10px",
                                    borderRadius: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <p
                                    style={{
                                      color: "black",
                                      fontSize: "14px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Test OTP (for development):
                                  </p>
                                  <p
                                    style={{
                                      color: "black",
                                      fontWeight: "700",
                                      fontSize: "18px",
                                      letterSpacing: "3px",
                                      marginBottom: "0",
                                    }}
                                  >
                                    {otpTesting}
                                  </p>
                                </div>
                              </div>

                              <div style={{ marginBottom: "25px" }}>
                                <input
                                  type="text"
                                  name="otp"
                                  value={otp}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  placeholder="Enter 4-digit OTP"
                                  maxLength={4}
                                  required
                                  disabled={isLoading}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    setOtp(value.slice(0, 4));
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "15px 20px",
                                    borderRadius: "10px",
                                    border:
                                      "2px solid rgba(254, 232, 148, 0.5)",
                                    fontSize: "20px",
                                    color: "black",
                                    background: "#fff",
                                    transition: "all 0.3s ease",
                                    outline: "none",
                                    textAlign: "center",
                                    letterSpacing: "10px",
                                    fontWeight: "600",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>

                              <div
                                className="mt-3 text-center"
                                style={{ marginTop: "30px" }}
                              >
                                <p
                                  className="mb-2"
                                  style={{ marginBottom: "15px" }}
                                >
                                  {resendTimer > 0 ? (
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        backgroundColor: "#1e40af",
                                        padding: "8px 15px",
                                        borderRadius: "20px",
                                      }}
                                    >
                                      <FaClock
                                        style={{
                                          marginRight: "8px",
                                          color: "#fff",
                                          fontSize: "14px",
                                        }}
                                      />
                                      <span
                                        style={{
                                          color: "#fff",
                                          fontWeight: "500",
                                        }}
                                      >
                                        Resend OTP in{" "}
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontWeight: "700",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {resendTimer}
                                        </span>{" "}
                                        seconds
                                      </span>
                                    </div>
                                  ) : (
                                    <a
                                      href="#!"
                                      onClick={handleResendOtp}
                                      style={{
                                        cursor: "pointer",
                                        color: "#fff",
                                        textDecoration: "none",
                                        fontWeight: "600",
                                        padding: "8px 20px",
                                        borderRadius: "20px",
                                        backgroundColor: "#1e40af",
                                        border:
                                          "1px solid rgba(254, 232, 148, 0.5)",
                                        transition: "all 0.3s ease",
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                      disabled={isLoading || resendTimer > 0}
                                    >
                                      <FaRedoAlt
                                        style={{ marginRight: "8px" }}
                                      />
                                      Resend OTP
                                    </a>
                                  )}
                                </p>

                                <a
                                  href="#!"
                                  onClick={resetForm}
                                  style={{
                                    cursor: "pointer",
                                    color: "#fff",
                                    textDecoration: "none",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    marginTop: "10px",
                                    opacity: 0.8,
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <FaArrowLeft style={{ marginRight: "8px" }} />
                                  Change Mobile Number
                                </a>
                              </div>
                            </div>
                            <div
                              className="button-box text-center"
                              style={{ position: "relative", zIndex: 2 }}
                            >
                              <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                  background: "#1e40af",
                                  color: "#fff",
                                  border: "none",
                                  padding: "14px 40px",
                                  borderRadius: "50px",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease",
                                  width: "100%",
                                  maxWidth: "300px",
                                  margin: "0 auto",
                                  display: "block",
                                  boxShadow: "0 5px 15px rgba(22, 0, 21, 0.3)",
                                }}
                              >
                                {isLoading ? (
                                  <span>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Verifying...
                                  </span>
                                ) : activeTab === "login" ? (
                                  <>
                                    <FaSignInAlt
                                      style={{
                                        marginRight: "8px",
                                        verticalAlign: "middle",
                                      }}
                                    />
                                    Login
                                  </>
                                ) : (
                                  <>
                                    <FaUserPlus
                                      style={{
                                        marginRight: "8px",
                                        verticalAlign: "middle",
                                      }}
                                    />
                                    Register
                                  </>
                                )}
                              </button>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Security />
      <Footer />
    </div>
  );
};

export default Login;
